import styled from 'styled-components'

export const MainContainer = styled.div`
  position: absolute;
  bottom: 32px;
  left: 32px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: start;
`

export const QuintileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Color = styled.span`
  width: ${props => props.theme.size.XS};
  height: ${props => props.theme.size.XS};
  background-color: ${props => props.color || '#ccc'};
`
